<script setup>
import { computed } from 'vue'

const props = defineProps({
  to: {
    type: Array,
    required: true,
  },
  emoji: {
    type: Array,
    required: true,
  },
  title: {
    type: Array,
    default: () => [],
  },
})

const buttons = computed(() => {
  return props.to
    .map((target, index) => ({
      to: target,
      emoji: props.emoji[index] || '',
      title: props.title[index] || '',
    }))
    .filter((item) => item.to && item.emoji)
})
</script>

<template>
  <div
    v-if="buttons.length > 0"
    class="emoji-bank"
  >
    <NuxtLink
      v-for="(button, index) in buttons"
      :key="`${button.to}-${index}`"
      :to="button.to"
      :title="button.title"
      :aria-label="button.title"
      class="emoji-bank__button"
      :class="{
        'emoji-bank__button--first': index === 0,
        'emoji-bank__button--last': index === buttons.length - 1,
      }"
    >
      <MDC
        :value="button.emoji"
        tag="span"
        class="emoji-bank__emoji"
      />
    </NuxtLink>
  </div>
</template>

<style lang="css" scoped>
.emoji-bank {
  @apply inline-flex items-stretch;
}

.emoji-bank__button {
  @apply inline-flex items-center justify-center shadow-md
         bg-gray-100 dark:bg-gray-800
         hover:bg-gray-200 hover:dark:bg-gray-700
         transition-all duration-200;

  padding: 0.75rem;
  line-height: 1;
}

.emoji-bank__button + .emoji-bank__button {
  border-left: 1px solid rgb(156 163 175 / 0.45);
}

.emoji-bank__button--first {
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}

.emoji-bank__button--last {
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}

.emoji-bank__emoji {
  font-size: 2.5rem;
  line-height: 1;
}
</style>
